import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { match } from "ts-pattern";

import type { SettingKey } from "@thalamos/haven-common";

import type { ReadOutcome } from "./readOutcome.js";

/**
 * The other settings a change alters, by name only: the values differ from one
 * organisation to the next, and the confirmation reads the same at any size.
 */
export const AlsoChanges = ({
  changes,
}: {
  changes: ReadOutcome<readonly SettingKey[]>;
}) => {
  const { t } = useTranslation();

  return (
    <Typography variant="body2">
      {match(changes)
        .with({ kind: "reading" }, () =>
          t("admin.configuration.settings.unsaved.alsoChangesReading"),
        )
        .with({ kind: "failed" }, () =>
          t("admin.configuration.settings.unsaved.alsoChangesFailed"),
        )
        .with({ kind: "read" }, ({ value }) =>
          value.length === 0
            ? t("admin.configuration.settings.unsaved.alsoChangesNothing")
            : t("admin.configuration.settings.unsaved.alsoChanges", {
                settings: value
                  .map((key) => t(`admin.configuration.settings.keys.${key}`))
                  .join(", "),
              }),
        )
        .exhaustive()}
    </Typography>
  );
};
